/**
 * The choices an alert is saved with, shared by the site's alert form
 * (/alerts/new) and the Telegram Mini App's alert sheet. The server checks
 * every one of them again (backend routes/alerts): these only decide what
 * a form offers.
 */

/** Cadences offered (owner call 2026-07-18: instant / hourly / daily /
 *  every 3 days / weekly). The legacy "30m" and "6h" still work for the
 *  alerts that have them but are no longer offered. */
export const OFFERED_FREQUENCIES = ["instant", "1h", "24h", "3d", "7d"] as const;

/** What a free account may pick (backend _FREE_FREQUENCIES); the faster
 *  cadences are Pro. */
export const FREE_FREQUENCIES: ReadonlySet<string> = new Set(["24h", "3d", "7d"]);

/** The deal levels an alert can wait for, loosest first. */
export const ALERT_TIERS = ["any", "good_deal", "great_deal", "exceptional_deal"] as const;
export type AlertTier = (typeof ALERT_TIERS)[number];

/** The site form's default level. */
export const DEFAULT_ALERT_TIER: AlertTier = "great_deal";

/** Land, commercial premises and garages carry no valuation, so their
 *  alerts take every new listing that fits (backend
 *  alert_matcher.unvalued). */
export function alertUnvalued(filters: Record<string, unknown>): boolean {
  const kinds = Array.isArray(filters.listing_kind) ? filters.listing_kind.map(String) : [];
  return ["land", "commercial", "garage"].includes(String(filters.category ?? "")) || kinds.includes("land");
}
